"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const ListItemSecondaryAction_1 = __importDefault(require("@material-ui/core/ListItemSecondaryAction"));
const md_1 = require("react-icons/md");
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const useStyles = (0, styles_1.makeStyles)((theme) => ({
    item: {
        backgroundColor: '#ECF5F9',
        color: '#1E678F',
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
    },
    itemText: {
        overflow: 'auto',
        maxWidth: '75%',
    },
    icon: {
        color: '#1E678F',
    },
    fileIcon: {
        color: '#E67337',
    },
}));
const OrderedList = (props) => {
    const { listItems, isFile, onChange, onOpenItem, onEditItem, onDeleteItem } = props;
    const classes = useStyles();
    return (react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onChange },
        react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "orderedList" }, (provided) => (react_1.default.createElement(List_1.default, { ...provided.droppableProps, ref: provided.innerRef },
            listItems.map(({ value, label }, index) => {
                return (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { key: value, draggableId: value, index: index }, (provided) => (react_1.default.createElement(Box_1.default, { my: 1, className: classes.item, ref: provided.innerRef, ...provided.draggableProps, ...provided.dragHandleProps },
                    react_1.default.createElement(ListItem_1.default, null,
                        react_1.default.createElement(ListItemIcon_1.default, null,
                            react_1.default.createElement(md_1.MdDragHandle, { className: classes.icon }),
                            isFile && react_1.default.createElement(md_1.MdDescription, { className: classes.fileIcon })),
                        react_1.default.createElement(ListItemText_1.default, { className: classes.itemText, primary: label }),
                        react_1.default.createElement(ListItemSecondaryAction_1.default, null,
                            onOpenItem && (react_1.default.createElement(IconButton_1.default, { edge: "end", onClick: () => onOpenItem(value, index) },
                                react_1.default.createElement(md_1.MdOpenInNew, { className: classes.icon }))),
                            onEditItem && (react_1.default.createElement(IconButton_1.default, { edge: "end", onClick: () => onEditItem(value, index) },
                                react_1.default.createElement(md_1.MdEdit, { className: classes.icon }))),
                            onDeleteItem && (react_1.default.createElement(IconButton_1.default, { edge: "end", onClick: () => onDeleteItem(value, index) },
                                react_1.default.createElement(md_1.MdDelete, { className: classes.icon })))))))));
            }),
            provided.placeholder)))));
};
OrderedList.propTypes = {
    listItems: prop_types_1.default.arrayOf(prop_types_1.default.object).isRequired,
    isFile: prop_types_1.default.bool,
    onChange: prop_types_1.default.any,
    onEditItem: prop_types_1.default.any,
    onOpenItem: prop_types_1.default.any,
    onDeleteItem: prop_types_1.default.any,
};
exports.default = OrderedList;
